import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Progress,
  Row,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";
import {
  postReferralTriggerEvent,
  putReferralTriggerEvent,
} from "store/referral-trigger-event/thunk";
import { NumericFormat } from "react-number-format";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import {
  COLOR_REFERRAL_REWARD_STATUS,
  COLOR_WITHDRAW_STATUS,
  getPlatFormImage,
  LIST_REFERRAL_REWARD_STATUS_OPTION,
  LIST_WITHDRAW_STATUS_OPTION,
} from "helpers/constans";
import UploadImage from "components/Common/UploadImage";
import {
  formatDateStringToKorea,
  formatNumberWithCommas,
  formatTimeISOString,
} from "helpers/format";
import { numericFormatter } from "react-number-format";
import avatar1 from "../../assets/images/users/ic_defaul_avatar2.png";
import CopyWrapper from "components/Common/CopyWrapper";
import { capitalizeFirstLetter } from "utils";
import GroupInfoUser from "components/Common/GroupInfoUser";
import TableContainer from "components/Common/TableContainer";
import TooltipCustom from "components/Common/TooltipCustom";
import UpdateDropdownStatus from "components/Common/UpdateDropdownStatus";
import { getWithdraw } from "store/request-withdraw/thunk";
import referralApi from "api/referralApi";

export interface Props {
  id?: string;
  item?: any;
  triggerRefresh?: () => void;
  onCloseClick?: any;
  setLinkImage?: any;
}

registerLocale("en", en);
registerLocale("ko", ko);

const WithdrawDetail = ({
  id = "",
  item,
  triggerRefresh,
  onCloseClick,
  setLinkImage,
}: Props) => {
  const { t, i18n } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFirstProgress, setIsFirstProgress] = useState<boolean>(true);
  const [statusSelected, setStatusSelected] = useState<string>("");
  const [waiting, setWaiting] = useState<boolean>(false);
  const [defaultValue, setDefaultValue] = useState<any>();
  const [isHideStatusTransaction, setIsHideStatusTransaction] =
    useState<boolean>(false);

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading((_prev) => true);

      const item: any = {
        note: values?.note,
        status: values?.status,
      };

      if (values?.status === "completed") {
        const arr = values?.files?.map((item: any) => ({ url: item?.url }));
        item.transfer_no = values?.transfer_no;
        item.transfer_amount = values?.transfer_amount;
        item.transfer_date = values?.transfer_date ? formatTimeISOString(values?.transfer_date) : "";
        item.image_urls = arr;
      }

      const response: any = await referralApi.updateWithdraw(id, item);

      if (response?.data) {
        setIsLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
        triggerRefresh && triggerRefresh();
      } else {
        setIsLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    // transfer_no: Yup.string().when("status", (status, schema) => {
    //   return status[0] === "completed"
    //     ? schema.required("Transfer No is required")
    //     : schema.notRequired();
    // }),
    // transfer_amount: Yup.string().when("status", (status, schema) => {
    //   return status[0] === "completed"
    //     ? schema.required("Amount is required")
    //     : schema.notRequired();
    // }),
    // transfer_date: Yup.string().when("status", (status, schema) => {
    //   return status[0] === "completed"
    //     ? schema.required("Transfer Date is required")
    //     : schema.notRequired();
    // }),
    // note: Yup.string().required("Note is required").max(500),
  });

  const formik = useFormik({
    initialValues: {
      transfer_no: "",
      transfer_amount: "",
      transfer_date: null,
      note: "",
      status: "",
      files: [],
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 70,
        Cell: ({ ...props }) => {
          return (
            <div style={{ minWidth: "60px" }}>{props?.row?.index + 1}</div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        filterable: false,
        sortable: false,
        thWidth: 80,
        thClass: "text-left whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const status = cell?.value;
          const msgError = item?.reason_rejected;

          return (
            <div
              className="position-relative d-flex align-items-center gap-1 justify-content-left"
              style={{ minWidth: 110 }}
            >
              <div className="text-center" style={{ lineHeight: "16px" }}>
                <span
                  className={`rounded-pill badge bg-${
                    COLOR_REFERRAL_REWARD_STATUS[status] || "secondary"
                  }`}
                >
                  {t(
                    LIST_REFERRAL_REWARD_STATUS_OPTION?.find(
                      (item: any) => String(item?.value) === String(status)
                    )?.label ?? ""
                  )}
                </span>
              </div>
              {status === "rejected" && msgError && (
                <TooltipCustom
                  title={t(msgError)}
                  className="d-inline-block vertical-align-middle ms-1 thumbnail-mt"
                  style={{
                    transform: "translateY(2px)",
                    position: "absolute",
                    top: "calc(50% - 9px)",
                    right: 0,
                    paddingLeft: 4,
                    paddingRight: 3,
                    lineHeight: "18px",
                  }}
                >
                  <i
                    className="ri-question-line align-bottom text-secondary"
                    style={{ fontSize: "16px" }}
                  ></i>
                </TooltipCustom>
              )}
            </div>
          );
        },
      },
      {
        Header: t("User"),
        accessor: "user",
        thClass: "align-middle text-start",
        filterable: false,
        sortable: false,
        thWidth: 600,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original?.user;

          return <GroupInfoUser item={item} />;
        },
      },
      {
        Header: t("Level"),
        accessor: "level",
        thWidth: 180,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="text-center" style={{ minWidth: 80 }}>
                {`${t("Level")} ${cell?.value}`}
              </div>
            )
          );
        },
      },
      {
        Header: t("Amount"),
        accessor: "amount",
        thClass: "text-end",
        thWidth: 150,
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <>
              <div className="text-end" style={{ minWidth: "100px" }}>
                <div>{formatNumberWithCommas(cell?.value || 0)}</div>
              </div>
            </>
          );
        },
      },
      {
        Header: `${t("Currency")}`,
        accessor: "currency",
        filterable: false,
        sortable: false,
        thWidth: 120,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          let imgPlatform = getPlatFormImage(cell?.value ?? "");

          return (
            cell?.value && (
              <div style={{ textAlign: "center", minWidth: 100 }}>
                {imgPlatform && (
                  <img
                    src={imgPlatform}
                    width={25}
                    height={25}
                    alt="currency"
                  />
                )}
              </div>
            )
          );
        },
      },
      {
        Header: t("Registered at"),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Trigger at"),
        accessor: "confirmed_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language]
  );

  const handleCloseToggle = () => {
    if (waiting) {
      triggerRefresh && triggerRefresh();
    } else {
      onCloseClick && onCloseClick();
    }
  };

  const handleHideTransaction = () => {
    setIsHideStatusTransaction(!isHideStatusTransaction);
  };

  const handleUpdateStatus = async (id: any, key: string, value: any) => {
    setStatusSelected(value);
    formik.setFieldValue("status", value);
    setIsHideStatusTransaction(false);
    if (value !== defaultValue?.status) {
      formik.setFieldValue("note", "");
    } else {
      formik.setFieldValue("note", defaultValue?.note);
    }
    try {
      const data = {
        status: value,
      };
      const response: any = await referralApi.updateWithdraw(id, data);

      if (response?.data) {
        setIsLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
        setWaiting(true);
        // triggerRefresh && triggerRefresh();
      } else {
        setIsLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const renderOptionsStatus = useMemo(() => {
    switch (statusSelected) {
      case "requested":
      case "needs_correction":
        return LIST_WITHDRAW_STATUS_OPTION.filter(
          (item: any) => item?.value === "processing"
        );

      case "processing":
        return LIST_WITHDRAW_STATUS_OPTION.filter(
          (item: any) =>
            item?.value === "completed" ||
            item?.value === "rejected" ||
            item?.value === "needs_correction"
        );

      case "completed":
      case "rejected":
      case "cancelled":
        return [];
      default:
        break;
    }
  }, [i18n?.language, statusSelected]);

  const handleSetValueForm = (data: any) => {
    formik.setValues({
      ...data,
      transfer_amount: data?.bank?.transfer_amount || "",
      transfer_no: data?.bank?.bank_transaction_no || "",
      transfer_date: data?.bank?.transfer_date
        ? new Date(formatDateStringToKorea(data?.bank?.transfer_date))
        : null,
      note: data?.note || "",
      status: data?.status || "",
      files: data?.image_urls || [],
    });
    setStatusSelected(data?.status);
  };

  const handleCallWithdraw = async (idItem: string) => {
    try {
      if (!idItem) {
        return;
      }
      const resDetail: any = await getWithdraw(idItem);

      if (resDetail?.data) {
        handleSetValueForm(resDetail?.data);
        setDefaultValue(resDetail?.data);
      }
    } catch (error: any) {
      return error;
    }
  };

  useEffect(() => {
    if (id) {
      handleCallWithdraw(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (item) {
      setStatusSelected("completed");
    }
  }, [item]);

  useEffect(() => {
    document.title = `${t("Detail Request Withdraw")} - ${t(
      "Request Withdraw"
    )} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  useEffect(() => {
    if (Object.keys(formik.errors).length > 0) {
      setIsFirstProgress(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(formik.errors).length]);

  return (
    <React.Fragment>
      <Modal isOpen={true} centered={true} scrollable={false} size="xl">
        <ModalHeader toggle={isLoading ? () => {} : handleCloseToggle}>
          {t("Detail Request Withdraw")}
        </ModalHeader>
        <ModalBody
          className="py-3 px-4"
          style={{ overflowY: "auto", maxHeight: "70vh" }}
        >
          <div className="mt-3">
            <form onSubmit={formik.handleSubmit}>
              <Row>
                <Col lg={4}>
                  <div className="mb-3">
                    <Label htmlFor="transfer_no" className="form-label">
                      {t("Transaction No")}:{" "}
                      <span className="text-secondary">{item?.code}</span>
                    </Label>
                  </div>
                </Col>

                <Col lg={4}>
                  <div className="mb-3">
                    <Label htmlFor="amount" className="form-label">
                      {t("Request Amount")}:{" "}
                      <span className="text-secondary">
                        {new Intl.NumberFormat().format(item?.amount)}
                      </span>{" "}
                      <img
                        src={getPlatFormImage(item?.currency)}
                        width={20}
                        height={20}
                        alt="platform"
                      />
                    </Label>
                  </div>
                </Col>

                <Col lg={4}>
                  <div className="mb-3">
                    <Label htmlFor="transfer_no" className="form-label">
                      {t("Requested at")}:{" "}
                      <span className="text-secondary">
                        {formatDateStringToKorea(item.requested_at)}
                      </span>
                    </Label>
                  </div>
                </Col>

                <Col lg={12}>
                  <div className="mb-1 d-flex align-items-center gap-2">
                    <Label className="mb-0">{t("Status")}: </Label>

                    {!renderOptionsStatus?.length ? (
                      <div
                        className={`bg-${COLOR_WITHDRAW_STATUS[statusSelected]} cursor-pointer`}
                        style={{
                          color: "white",
                          borderRadius: "25px",
                          padding: "0px 14px",
                          height: "100%",
                          fontSize: "13px",
                        }}
                      >
                        {t(
                          LIST_WITHDRAW_STATUS_OPTION?.find(
                            (i) => i.value === statusSelected
                          )?.label || ""
                        )}
                      </div>
                    ) : (
                      <UpdateDropdownStatus
                        item={item}
                        valueDefault={statusSelected}
                        labelDefault={t(
                          LIST_WITHDRAW_STATUS_OPTION?.find(
                            (i) => i.value === statusSelected
                          )?.label || ""
                        )}
                        handleUpdateStatus={handleUpdateStatus}
                        optionsStatus={renderOptionsStatus}
                        colorStatus={COLOR_WITHDRAW_STATUS}
                      />
                    )}
                  </div>

                  {statusSelected === "completed" && (
                    <div>
                      <div
                        className="cursor-pointer"
                        style={{ width: "fit-content" }}
                        onClick={handleHideTransaction}
                      >
                        <small className="text-primary text-decoration-underline w-full">
                          {t(
                            `${
                              isHideStatusTransaction
                                ? "Hide details"
                                : "Add optional details"
                            }`
                          )}
                        </small>
                      </div>
                      {isHideStatusTransaction && (
                        <Card className="p-3" style={{ background: "#F7F7F7" }}>
                          <Row>
                            <Col lg={4}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="transfer_no"
                                  className="form-label"
                                >
                                  {t("Bank Transaction No")}{" "}
                                  {/* <span className="text-danger"> *</span> */}
                                </Label>

                                <Input
                                  name="transfer_no"
                                  type="text"
                                  className="form-control"
                                  id="transfer_no"
                                  placeholder={t("Bank Transaction No")}
                                  value={formik?.values?.transfer_no}
                                  onChange={(event: any) =>
                                    formik.setFieldValue(
                                      "transfer_no",
                                      event?.target?.value
                                    )
                                  }
                                />

                                {formik.touched.transfer_no &&
                                formik.errors.transfer_no ? (
                                  <div className="text-danger mt-2">
                                    {formik.errors.transfer_no}
                                  </div>
                                ) : null}
                              </div>
                            </Col>

                            <Col lg={3}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="transfer_amount"
                                  className="form-label"
                                >
                                  {t("Amount")}{" "}
                                  {/* <span className="text-danger"> *</span> */}
                                </Label>

                                <Input
                                  name="transfer_amount"
                                  type="number"
                                  className="form-control"
                                  id="transfer_amount"
                                  placeholder={t("Amount")}
                                  value={formik?.values?.transfer_amount}
                                  onChange={(event: any) =>
                                    formik.setFieldValue(
                                      "transfer_amount",
                                      event?.target?.value
                                    )
                                  }
                                />

                                {formik.touched.transfer_amount &&
                                formik.errors.transfer_amount ? (
                                  <div className="text-danger mt-2">
                                    {formik.errors.transfer_amount}
                                  </div>
                                ) : null}
                              </div>
                            </Col>
                            {/* <Col lg={3}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="transfer_amount"
                                  className="form-label"
                                >
                                  {t("Amount")}{" "}
                                  <span className="text-danger"> *</span>
                                </Label>

                                <NumericFormat
                                  name="transfer_amount"
                                  className="form-control"
                                  placeholder={t("Amount")}
                                  value={formik?.values?.transfer_amount}
                                  allowLeadingZeros
                                  thousandSeparator=","
                                  onValueChange={(values: any) => {
                                    const { floatValue } = values;
                                    formik.setFieldValue(
                                      "transfer_amount",
                                      floatValue
                                    );
                                  }}
                                />
                                {formik.touched.transfer_amount &&
                                formik.errors.transfer_amount ? (
                                  <div className="text-danger mt-2">
                                    {formik.errors.transfer_amount}
                                  </div>
                                ) : null}
                              </div>
                            </Col> */}
                            <Col lg={5} className="datepicker-time">
                              <div className="mb-3">
                                <Label
                                  htmlFor="transfer_date"
                                  className="form-label"
                                >
                                  {t("Transfer Date")}{" "}
                                  {/* <span className="text-danger">*</span> */}
                                </Label>

                                <div className="w-100">
                                  <DatePicker
                                    name={"transfer_date"}
                                    className="form-control"
                                    selected={
                                      formik?.values?.transfer_date ?? null
                                    }
                                    placeholderText={t("Select time")}
                                    onChange={(date: any) => {
                                      formik.setFieldValue(
                                        "transfer_date",
                                        date
                                      );
                                    }}
                                    dateFormat="yyyy-MM-dd HH:mm:ss"
                                    // isClearable={true}
                                    showTimeSelect
                                  />
                                </div>

                                {formik.touched.transfer_date &&
                                formik.errors.transfer_date ? (
                                  <div className="text-danger mt-2">
                                    {formik.errors.transfer_date + ""}
                                  </div>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <Label htmlFor="amount" className="form-label">
                                  {t("Note")}{" "}
                                  {/* <span className="text-danger"> *</span> */}
                                </Label>

                                <textarea
                                  className="form-control"
                                  id="note"
                                  name="note"
                                  value={formik?.values?.note}
                                  placeholder={`${t("Note")}...`}
                                  onChange={(event: any) => {
                                    formik.setFieldValue(
                                      "note",
                                      event?.target?.value || ""
                                    );
                                  }}
                                  style={{ height: 150 }}
                                />

                                {formik.touched.note && formik.errors.note ? (
                                  <div className="text-danger mt-2">
                                    {formik.errors.note}
                                  </div>
                                ) : null}
                              </div>
                            </Col>
                            <Col xxl={12}>
                              <label className="form-label">{t("Files")}</label>

                              <UploadImage
                                data={formik.getFieldProps("files")?.value}
                                setLinkImage={setLinkImage}
                                formik={formik}
                                uploadProps={{ maxCount: 3, accept: "image/*" }}
                              />
                            </Col>
                            <Col lg={12}>
                              <div className="hstack gap-2 justify-content-end mt-3">
                                <button
                                  className="btn btn-primary fs-14"
                                  color="success"
                                  type="submit"
                                  disabled={isLoading}
                                  style={{ width: "80px" }}
                                >
                                  {isLoading ? (
                                    <Spinner
                                      size="sm"
                                      className="me-2"
                                    ></Spinner>
                                  ) : (
                                    <>{t("Save")}</>
                                  )}
                                </button>
                              </div>
                            </Col>
                          </Row>
                        </Card>
                      )}
                    </div>
                  )}

                  {(statusSelected === "rejected" ||
                    statusSelected === "needs_correction") && (
                    <React.Fragment>
                      <div
                        className="cursor-pointer"
                        onClick={handleHideTransaction}
                        style={{ width: "fit-content" }}
                      >
                        <small className="text-primary text-decoration-underline w-full">
                          {t(`${isHideStatusTransaction ? "Hide" : "Show"}`)}
                        </small>
                      </div>
                      {isHideStatusTransaction && (
                        <Card className="p-3" style={{ background: "#F7F7F7" }}>
                          <Row>
                            <Col lg={12}>
                              <div className="mb-3">
                                <Label htmlFor="amount" className="form-label">
                                  {statusSelected === "rejected"
                                    ? t("Reason")
                                    : t("Note")}{" "}
                                  {/* <span className="text-danger"> *</span> */}
                                </Label>

                                <textarea
                                  className="form-control"
                                  id="note"
                                  name="note"
                                  value={formik?.values?.note}
                                  placeholder={`${
                                    statusSelected === "rejected"
                                      ? t("Reason")
                                      : t("Note")
                                  }...`}
                                  onChange={(event: any) => {
                                    formik.setFieldValue(
                                      "note",
                                      event?.target?.value || ""
                                    );
                                  }}
                                  style={{ height: 150 }}
                                />

                                {formik.touched.note && formik.errors.note ? (
                                  <div className="text-danger mt-2">
                                    {formik.errors.note}
                                  </div>
                                ) : null}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="hstack gap-2 justify-content-end mt-3">
                                <button
                                  className="btn btn-primary fs-14"
                                  color="success"
                                  type="submit"
                                  disabled={isLoading}
                                  style={{ width: "80px" }}
                                >
                                  {isLoading ? (
                                    <Spinner
                                      size="sm"
                                      className="me-2"
                                    ></Spinner>
                                  ) : (
                                    <>{t("Save")}</>
                                  )}
                                </button>
                              </div>
                            </Col>
                          </Row>
                        </Card>
                      )}
                    </React.Fragment>
                  )}
                </Col>

                <Col lg={12}>
                  <div className="d-flex gap-4 flex-wrap w-full flex-row mt-3">
                    <Card
                      className="p-3"
                      style={{ minWidth: 300, background: "#F7F7F7" }}
                    >
                      <h5 className="mb-3 d-flex align-items-center gap-2">
                        {t("User Request")}
                      </h5>
                      <div>
                        <GroupInfoUser item={item?.user} />
                      </div>
                    </Card>

                    <Card
                      className="p-3"
                      style={{ minWidth: 300, background: "#F7F7F7" }}
                    >
                      <h5 className="mb-2 d-flex align-items-center gap-2">
                        {t("Bank Information")}
                      </h5>
                      <div>
                        <div className="d-flex gap-2">
                          {t("Bank Name")}: <span>{item?.bank?.bank_name}</span>
                        </div>
                        <div className="d-flex gap-2">
                          {t("Account Holder Name")}:{" "}
                          <span>{item?.bank?.bank_account_holder_name}</span>
                        </div>
                        <div className="d-flex gap-2">
                          {t("Account Number")}:{" "}
                          <span>{item?.bank?.bank_account_number}</span>
                        </div>
                      </div>
                    </Card>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col xl={12}>
                  <h5 className="form-label">{t("Transaction List")}</h5>
                  <div>
                    <div>
                      <TableContainer
                        className="custom-header-css"
                        divClass="table-responsive"
                        tableClass="align-middle table-bordered-dashed"
                        theadClass="table-light text-muted"
                        columns={columns}
                        data={
                          item?.transaction_detail?.length
                            ? item?.transaction_detail
                            : []
                        }
                        totalRecords={item?.transaction_detail?.length}
                        manualSorting={true}
                        isShowPagination={false}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </form>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default WithdrawDetail;
